export default "__VITE_ASSET__8NbJi9bP__"